import { Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import RestoreModal from 'widgets/restore/restoreModal';
import { useTranslation } from 'react-i18next';
import React, { useContext, useState } from 'react';
import { MobxContext } from 'shared/lib/contexts/mobxContext';
import { AxiosError } from 'axios';
import { BackErrors } from 'shared/lib/utils/globalUtils';
import ErrorModal from 'shared/lib/components/modals/errorModal';
import { trashApi } from 'entities/trash/api/trashApi';

export type RestoreTableModalActions = {
  afterTableRestore?: (table: { id: string; name: string }) => void;
};

export default observer(function RestoreTableModalController({
  table,
  afterTableRestore,
  handleClose,
}: {
  table: { id: string; name: string };
  handleClose: () => void;
} & RestoreTableModalActions) {
  const { mobxStore } = useContext(MobxContext);
  const { t } = useTranslation();

  const errorHeader = 'Ошибка действия';

  const [dublicateName, setDublicateName] = useState<null | string>(null);

  return (
    <>
      <RestoreModal
        isOpen={true}
        handleClose={handleClose}
        initialSectionId={null}
        initialFolderId={null}
        headerText={t('actions.restoring.table')}
        applyText={t('common.restore')}
        onSubmit={async (params) => {
          try {
            await trashApi.restoreTable(table.id, {
              folder_id: params.folderId,
              section_id: params.sectionId,
            });

            afterTableRestore && afterTableRestore(table);
          } catch (e) {
            const err = e as AxiosError<{ detail?: string }>;
            console.error(e);

            if (
              err?.response?.status === 400 &&
              (err?.response?.data?.detail === BackErrors.FileExists ||
                err?.response?.data?.detail === BackErrors.TableExists)
            ) {
              setDublicateName(table.name);
              return;
            }

            mobxStore.notificationsStore.errorMessage = t(
              'notifications.errors.default'
            );
          }

          handleClose();
        }}
      ></RestoreModal>

      {dublicateName && (
        <ErrorModal
          mainText={errorHeader}
          isOpen={true}
          onClose={() => setDublicateName(null)}
        >
          <Typography variant="f18" sx={{ fontWeight: 300 }}>
            Действие невозможно&nbsp;&mdash; объект с&nbsp;таким названием уже
            существует по&nbsp;указанному адресу
          </Typography>
        </ErrorModal>
      )}
    </>
  );
});
